<form class="flex justify-between flex-col h-full">
  <div class="text-ladder-black">
    <h1 class="font-bold text-3xl">Forgot your password?</h1>
    <p class="text-base opacity-80 mt-2">
      Enter your account email to receive a recovery link.
    </p>

    <div class="form-group mt-5">
      <label for="email">Email Address</label>
      <input
        id="email"
        placeholder="esteban_schiller@gmail.com"
        type="email"
        autocapitalize="off"
        autocomplete="off"
      />
    </div>
  </div>

  <div class="w-full grid grid-cols-2 items-center justify-center gap-2 mb-5">
    <a class="col-span-2 md:col-span-1 font-bold text-ladder-black text-opacity-60 text-lg text-center max-md:order-2" [routerLink]="'/auth/login'">← Back to Log In</a>
    <app-button class="font-bold md:col-span-1 col-span-2 max-md:order-1">Request recovery</app-button>
  </div>
</form>
